export default "__VITE_ASSET__h_3KDQu___"